import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartEngagementFieldPack: FieldPack = {
  id: 'orgchart-engagement',
  name: 'Engagement (Planning Overlay)',
  description: 'Engagement and satisfaction data used as context overlay during succession and workforce planning',
  version: '1.0.0',
  dependencies: ['orgchart-base'],
  fields: [
    {
      id: 'engagementScore',
      label: 'Engagement Score',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 80,
      namespace: 'engagement',
      min: 0,
      max: 100,
      sensitivity: 'manager',
    },
    {
      id: 'eNPS',
      label: 'eNPS Score',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 75,
      namespace: 'engagement',
      min: -100,
      max: 100,
      sensitivity: 'manager',
    },
    {
      id: 'lastSurveyDate',
      label: 'Last Survey Date',
      type: FieldType.DATE,
      tags: ['engagement'],
      priority: 70,
      namespace: 'engagement',
      sensitivity: 'manager',
    },
    {
      id: 'satisfactionScore',
      label: 'Satisfaction Score',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 65,
      namespace: 'engagement',
      min: 0,
      max: 10,
      step: 0.1,
      sensitivity: 'manager',
    },
    {
      id: 'managerRating',
      label: 'Manager Rating (by team)',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 60,
      namespace: 'engagement',
      min: 0,
      max: 5,
      step: 0.1,
      sensitivity: 'manager',
    },
    {
      id: 'absenteeismRate',
      label: 'Absenteeism Rate',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 55,
      namespace: 'engagement',
      min: 0,
      max: 100,
      step: 0.1,
      sensitivity: 'manager',
    },
    {
      id: 'voluntaryTurnoverRisk',
      label: 'Turnover Prediction',
      type: FieldType.NUMBER,
      tags: ['engagement', 'retention'],
      priority: 50,
      namespace: 'engagement',
      min: 0,
      max: 100,
      sensitivity: 'manager',
    },
    {
      id: 'lastOneOnOneDate',
      label: 'Last 1:1 Date',
      type: FieldType.DATE,
      tags: ['engagement'],
      priority: 45,
      namespace: 'engagement',
      sensitivity: 'manager',
    },
    {
      id: 'recognitionsReceived',
      label: 'Recognitions',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 40,
      namespace: 'engagement',
      min: 0,
      sensitivity: 'manager',
    },
    {
      id: 'recognitionsGiven',
      label: 'Recognitions Given',
      type: FieldType.NUMBER,
      tags: ['engagement'],
      priority: 35,
      namespace: 'engagement',
      min: 0,
      sensitivity: 'manager',
    },
  ],
};
